export const ITEM_TYPES = ["T-Shirts", "Long Sleeve T-Shirts", "Hoodies", "Hats", "Mugs", "Stickers", "DTF Transfers", "UV Printing", "Business Branding", "Bulk Order", "Other / Not Sure"];
export const PLACEMENTS = ["Front center", "Left chest", "Back center", "Front and back", "Left chest + full back", "Sleeve / side", "Custom placement", "Not sure yet"];
export const QUOTE_SERVICES = ["Custom apparel", "Embroidery", "DTF transfers", "UV printing", "Stickers / decals", "Business branding", "Bulk order", "Other"];
export const STATUSES = [
  { value: "new", label: "New", color: "bg-red-600 text-white" },
  { value: "reviewing", label: "Reviewing", color: "bg-amber-500 text-black" },
  { value: "invoice_sent", label: "Invoice Sent", color: "bg-sky-500 text-black" },
  { value: "paid", label: "Paid", color: "bg-emerald-500 text-black" },
  { value: "in_production", label: "In Production", color: "bg-blue-600 text-white" },
  { value: "ready", label: "Ready for Pickup", color: "bg-violet-500 text-white" },
  { value: "completed", label: "Completed", color: "bg-slate-500 text-white" },
  { value: "cancelled", label: "Cancelled", color: "bg-zinc-700 text-zinc-300" },
];
export const statusOf = (v) => STATUSES.find((s) => s.value === v) || STATUSES[0];
export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/design", label: "Design Studio" },
  { to: "/work", label: "Our Work" },
  { to: "/about", label: "About Us" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blank-apparel", label: "Blank Apparel" },
  { to: "/policies", label: "Policies" },
  { to: "/quote", label: "Contact" },
];
